import React, { useState } from 'react';
import { useFormik } from 'formik';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';

function RejectAttendancePopup({ updateRejectRow, rejectRow, onClose }) {
    const [formData, setFormData] = useState({});
    const formik = useFormik({
        initialValues: {
            reason: '',
        },
        validate: (data) => {
            let errors = {};
            if (!data.reason) { errors.reason = 'Please add your reason'; }
            return errors;
        },
        onSubmit: (data) => {
            setFormData(data);
            updateRejectRow(data);
            onClose();
        }
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    const onCloseMethod = () => {
        onClose();
    }

    const rejectAttendancePopupForm = (
        <React.Fragment>
            <form onSubmit={formik.handleSubmit} className="p-fluid p-grid" autoComplete="off">
            <p style={{fontSize:'205%',position: 'absolute',top:'-10px', 'fontWeight':'700'}}>Reject Attendance</p>
                <div className="formgrid grid">
                    <div className="field col-5"></div>
                    {/* <div className="field col-4">
                        <Button icon="pi pi-ban" type='button' className='p-button-rounded p-button-secondary' style={{ width: '50px', height: '50px', backgroundColor: "red" }} />
                    </div> */}
                    <div className="field col-3"></div>

                    <div className="field col-4"></div>
                    <div className="field col-5" style={{ fontSize: '16px', fontWeight: 'bold' }}>{rejectRow.date}</div>
                    <div className="field col-3"></div>
                    <p style={{ paddingLeft: '10px' }}>Please mention your reason to reject this Attendance</p>
                </div>
                {getFormErrorMessage('reason')}
                {/* <div style={{paddingBottom:'5px'}}>Reason</div> */}
                <div className="formgrid grid">
                    <div className="field col">
                        <InputTextarea id="reason" name="reason" value={formik.values.reason} onChange={formik.handleChange} rows={5} cols={44} autoResize />
                    </div>
                </div>
                <div className="formgrid grid">
                    <div className="field col-3">
                    </div>
                    <div className="field col-4">
                        <Button type='button' label="Cancel" icon="pi pi-times" className="p-button-rounded p-button-secondary" onClick={(e) => onCloseMethod(e)} />
                    </div>
                    <div className="field col-5">
                        <Button label="Reject" icon="pi pi-check" className="p-button-rounded pi-button-secondary" style={{ "backgroundColor": "red" }} />
                    </div>
                </div>
            </form>
        </React.Fragment>
    );

    return (
        <React.Fragment>
            {rejectAttendancePopupForm}
        </React.Fragment>
    )
}

export default RejectAttendancePopup;